module.exports = __webpack_public_path__ + "static/media/playback-mode-icon.0c8fe98d.svg";